import { Descriptions, Tag } from 'antd';
import { formatDateTime } from 'utils/formatDate';

const ItemDetail = ({ item }) => {
  const changeColor =
    item.change > 0 ? 'green' : item.change < 0 ? 'red' : 'default';

  return (
    <Descriptions column={1} bordered>
      <Descriptions.Item label="ID">{item.id}</Descriptions.Item>
      <Descriptions.Item label="Symbol">
        <Tag color="blue">{item.symbol}</Tag>
      </Descriptions.Item>
      <Descriptions.Item label="Name">{item.name}</Descriptions.Item>
      <Descriptions.Item label="Exchange">{item.exchange}</Descriptions.Item>
      <Descriptions.Item label="Description">
        {item.description}
      </Descriptions.Item>
      <Descriptions.Item label="Featured">
        {item.featured ? <Tag color="gold">Featured</Tag> : 'No'}
      </Descriptions.Item>
      <Descriptions.Item label="Open">{item.open}</Descriptions.Item>
      <Descriptions.Item label="High">{item.high}</Descriptions.Item>
      <Descriptions.Item label="Low">{item.low}</Descriptions.Item>
      <Descriptions.Item label="Reference">{item.reference}</Descriptions.Item>
      <Descriptions.Item label="Value">{item.value}</Descriptions.Item>
      <Descriptions.Item label="Change">
        <Tag color={changeColor}>
          {item.change} ({item.change_percentage}%)
        </Tag>
      </Descriptions.Item>
      <Descriptions.Item label="Volume">{item.volume}</Descriptions.Item>
      <Descriptions.Item label="Trade Date">
        {formatDateTime(item.trade_date)}
      </Descriptions.Item>
      <Descriptions.Item label="Updated At">
        {formatDateTime(item.updated_at)}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default ItemDetail;
